import { GridType } from 'angular-gridster2';
import { IEntity, ObjectState } from '../interfaces/entity';

export interface ITemplateList {
  items: Template[];
  totalCount: number;
}

export class Template implements IEntity {
  id: number;
  uid: string;
  userId: number;
  type: string;
  layoutData: string;
  objectState: ObjectState;

  constructor(type?: string, template?) {
    template = template || {};
    this.id = template.id;
    this.uid = template.uid;
    this.userId = template.userId;
    this.type = type || template.type;
    this.layoutData = template.layoutData;
    this.objectState = template.objectState;
  }

  get layoutItems(): LayoutItem[] {
    const val: LayoutItem[] = this.layoutData
      ? JSON.parse(this.layoutData)
      : [];
    return val;
  }

  getSize() {
    let x = 0;
    let y = 0;
    this.layoutItems.forEach((item) => {
      const maxX = item.layoutInformation.x + item.layoutInformation.cols;
      const maxY = item.layoutInformation.y + item.layoutInformation.rows;
      if (maxX > x) {
        x = maxX;
      }
      if (maxY > y) {
        y = maxY;
      }
    });
    return {
      x,
      y,
    };
  }

  getSizeAndOptions(cellWidthAndHeight?: number, maxX?: number, maxY?: number) {
    cellWidthAndHeight = cellWidthAndHeight || 70; // default cellWidthHeight = 70

    // specify a max width and height
    maxX = maxX || 980; // default cellWidthAndHeight*14;
    maxY = maxY || 560; // default cellWidthAndHeight*8;

    // specify a min width and height
    const minX = 280; // default cellWidthAndHeight*4;
    const minY = 70; // default cellWidthAndHeight*1;

    const templateSize = this.getSize();
    const x = templateSize.x * cellWidthAndHeight;
    const y = templateSize.y * cellWidthAndHeight;

    return {
      sizeX: x > maxX ? maxX : x > 0 ? x : minX,
      sizeY: y > maxY ? maxY : y > 0 ? y : minY,
      options: {
        gridType: GridType.Fixed,
        fixedColWidth: cellWidthAndHeight,
        fixedRowHeight: cellWidthAndHeight,
        mobileBreakpoint: cellWidthAndHeight * 3,
        margin: 0,
        minCols: 1,
        maxCols: templateSize.x,
        minRows: 1,
        maxRows: templateSize.y,
        draggable: {
          enabled: false,
        },
        resizable: {
          enabled: false,
        },
      },
    };
  }
}

// tslint:disable-next-line:max-classes-per-file
export class LayoutItem {
  id: number;
  name: string;
  type: string;
  layoutInformation: {
    x?: number;
    y?: number;
    cols: number;
    rows: number;
  };
  metadata: any;
  // used to hold corresponding properties of widget
  configurable?: boolean;
  settings?: any;
}

export const TEMPLATE_TYPE = {
  CARD: 'CARD',
  EDIT: 'EDIT',
  LIST: 'LIST',
  DASHBOARD: 'DASHBOARD',
  REFERRAL: 'REFERRAL',
  REFERRALCARD: 'REFERRALCARD',
  REFERRALDASHBOARD: 'REFERRALDASHBOARD',
};
